/**
 * Catálogo de estados de reunión (mapeo etapa Kommo → indicador).
 * @module-isolated analytics
 */
export const MEETING_STATUSES = [
  { id: 'unscheduled', label: 'Sin agendar', homeLabel: 'Sin agendar' },
  {
    id: 'wont_schedule',
    label: 'No agendará',
    homeLabel: 'No van a agendar'
  },
  { id: 'scheduled', label: 'Agendada', homeLabel: 'Reuniones agendadas' },
  { id: 'cancelled', label: 'Cancelada', homeLabel: 'Canceladas' },
  { id: 'realized', label: 'Realizada', homeLabel: 'Realizadas' },
  { id: 'noshow', label: 'No se presentó', homeLabel: 'No se presentó' }
];

export function meetingStatusLabel(id) {
  const row = MEETING_STATUSES.find((s) => s.id === id);
  return row ? row.label : '';
}

export function emptyMeetingCounts() {
  const counts = {};
  MEETING_STATUSES.forEach((s) => {
    counts[s.id] = 0;
  });
  return counts;
}
